import { render } from "./TimeFormatter.vue?vue&type=template&id=b7261dfa&scoped=true&ts=true"
import script from "./TimeFormatter.vue?vue&type=script&lang=ts"
export * from "./TimeFormatter.vue?vue&type=script&lang=ts"

import "./TimeFormatter.vue?vue&type=style&index=0&id=b7261dfa&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7261dfa"]])

export default __exports__